import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import BasicSetting from './BasicSetting'
import ContentsHeader from './ContentsHeader'
import ContentsWeatherAreaCode from './ContentsWeatherAreaCode'
import ContentsViewerMode from './ContentsViewerMode'
import ContentsScreenSaver from './ContentsScreenSaver'
import ContentsLiveCamera from './ContentsLiveCamera'
import ContentsDesign from './ContentsDesign'
import ContentsNoticeSound from './ContentsNoticeSound'
import ContentsKeyAssignments from './ContentsKeyAssignments'

export default {
  name: 'ServiceContentsSettingInput',
  components: {
    Loading,
    BasicSetting,
    ContentsHeader,
    ContentsWeatherAreaCode,
    ContentsViewerMode,
    ContentsScreenSaver,
    ContentsLiveCamera,
    ContentsDesign,
    ContentsNoticeSound,
    ContentsKeyAssignments
  },
  data () {
    return {
      proccesing: false
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceContentsSetting.categoryName,

      // form
      serviceId: state => state.serviceContentsSettingForm.serviceId,
      serviceContentsId: state => state.serviceContentsSettingForm.targetId,
      values: state => state.serviceContentsSettingForm.values,

      // validate
      validates: state => state.serviceContentsSettingForm.validates,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept,

      // result
      resultServiceContentsId: state => state.serviceContentsSettingForm.serviceContentsId,
    }),
    ...mapGetters({
      permittedView: 'permission/permittedView',
      isRegister: 'serviceContentsSettingForm/isRegister',
      isModify: 'serviceContentsSettingForm/isModify',
      formIsValid: 'serviceContentsSettingForm/formIsValid',
    }),

    // validate
    disableConfirmButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }
    },
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
    }),
    ...mapMutations({
      // setValues: 'serviceContentsSettingForm/setValues',
      // setInputValue: 'serviceContentsSettingForm/setInputValue'
    }),

    init () {

    },
    turnBack () {
      this.$router.push({
        name: 'ServiceContentsSetting',
        params: {
          serviceId: this.serviceId
        }
      })
    },

    confirmData () {
      // validate
      if (this.formIsValid) {
        console.log('basicSetting', this.$refs.basicSetting.getJsonb)
        console.log('contentsHeader', this.$refs.contentsHeader.getJsonb)
        console.log('contentsWeatherAreaCode', this.$refs.contentsWeatherAreaCode.getJsonb)
        console.log('contentsViewerMode', this.$refs.contentsViewerMode.getJsonb)
        console.log('contentsScreenSaver', this.$refs.contentsScreenSaver.getJsonb)
        console.log('contentsLiveCamera', this.$refs.contentsLiveCamera.getJsonb)
        console.log('contentsDesign', this.$refs.contentsDesign.getJsonb)
        console.log('contentsNoticeSound', this.$refs.contentsNoticeSound.getJsonb)
        console.log('contentsKeyAssignments', this.$refs.contentsKeyAssignments.getJsonb)

        this.showConfirm({
          key: 'register',
          title: '',
          body: this.isRegister ?
            'この内容で' + this.categoryName + '基本設定を登録しますか？' :
            '「Id : ' + this.resultServiceContentsId + '」の' + this.categoryName + '基本設定を変更しますか？'
        })
      }
    },
    postData () {
      this.processing = true
      console.log('POST')

      // jsonb
      const jsonb = {
        contentsBasicSetting: this.$refs.basicSetting.getJsonb,
        contentsHeader: this.$refs.contentsHeader.getJsonb,
        // contentsWeatherAreaCode: this.$refs.contentsWeatherAreaCode.getJsonb,
        contentsViewerMode: this.$refs.contentsViewerMode.getJsonb,
        contentsScreenSaver: this.$refs.contentsScreenSaver.getJsonb,
        contentsLiveCamera: this.$refs.contentsLiveCamera.getJsonb,
        contentsDesign: this.$refs.contentsDesign.getJsonb,
        contentsNoticeSound: this.$refs.contentsNoticeSound.getJsonb,
        contentsKeyAssignments: this.$refs.contentsKeyAssignments.getJsonb,
      }
      if (this.$refs.contentsWeatherAreaCode.getJsonb) {
        jsonb.contentsWeatherAreaCode = this.$refs.contentsWeatherAreaCode.getJsonb
      }

      //
      let parameters = {
        serviceUuid: this.serviceId,
        request: {
          serviceContentsSettings: jsonb
        }
      }
      if (this.isModify) {
        parameters.serviceContentsUuid = this.serviceContentsId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceContentsSetting'],
        [this.isRegister ?
          'v1ServiceContentsSettingPost' :
          'v1ServiceContentsSettingPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.isRegister ?
                '新しい' + this.categoryName + '基本情報の登録' :
                this.categoryName + '基本情報の変更',
              body: this.isRegister ?
                this.categoryName + '基本情報のを登録しました。' :
                this.categoryName + '基本情報のを変更しました。'
            })

            // 
            this.$router.push({
              name: 'ServiceContentsSetting',
              params: {
                serviceId: this.serviceId
              }
            })

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    }
  }
}
